

function BizTransportForm() {
  return (
<div>사업자배송대행폼
</div>
  );
}

export default BizTransportForm;
